import { atom } from "recoil";

export const adminSettingVisibleState = atom({
  key: 'adminSettingVisibleState',
  default: false
});
